import React from 'react';
import CabecalhoGrafico from 'components/Windx/CabecalhoGrafico';
import TabelaComparativoSM from 'components/Windx/TabelaComparativoSM';
import useIsMobile from 'utils/hooks/useIsMobile';

import ComparativoMobile from './Mobile';

export default function WindxComparativo() {
  const isMobile = useIsMobile();

  if (isMobile) return <ComparativoMobile />;

  // WINDX-038 Frente B: wrapper flex container — ver SemiHorario/index.tsx.
  // TabelaComparativoSM nao usa ChartComSliders mas se beneficia do flex
  // (scroll interno tem mais area disponivel).
  return (
    <div className="p-4 d-flex flex-column flex-grow-1" style={{ minHeight: 0 }}>
      {/*
        permiteSelecaoVazia: nesta tela o backend trata `id_entidades=[]`
        como "todas as entidades". As outras telas Windx (SH e Semanal)
        exigem ao menos uma entidade selecionada — por isso o fallback
        fica restrito a Comparativo.
      */}
      <CabecalhoGrafico tela="sm" permiteSelecaoVazia showDownload={false}>
        <TabelaComparativoSM />
      </CabecalhoGrafico>
    </div>
  );
}
